import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useHistory } from 'react-router-dom';
import styles from './credito.module.sass';
// import CurrencyFormat from 'react-currency-format';
import { BASE_PATH, BASE_PATH_PORTAL, SUB_DIRECTORY } from 'constants/general';

import { dataLayerButtons } from 'functions/dataLayerFunction';
import { dateFormatDDMMYY, dateFormatDDMM } from 'functions/dateFormat';
import { encodeStorage, decodeStorage } from 'functions/storageBase64';

import { ElegirPlan, PagarPlan } from 'components/Credito/ButtonPayCard';
import ModalCredito from 'components/Modal';
import HistorialNav from 'components/HistorialNav';


export function useHomePage(dataSaldos) {

    const [escenarioHome, setEscenarioHome] = useState(0)

    const [titulo, setTitulo] = useState(dataSaldos?.titulo)
    const [accountNumber, setAccountNumber] = useState(dataSaldos?.accountNumber)
    const [newType, setNewType] = useState(dataSaldos?.newType)
    const [cardending, setCardending] = useState(dataSaldos?.cardending)
    const [fechaPago, setFechaPago] = useState(dataSaldos?.fechaPago)
    const [fechaLimite, setFechaLimite] = useState(dataSaldos?.fechaLimite)
    const [saldoDisponible, setSaldoDisponible] = useState(dataSaldos?.saldoDisponible)
    const [montoMinimo, setMontoMinimo] = useState(dataSaldos?.montoMinimo)
    const [montoLimiteCredito, setMontoLimiteCredito] = useState(dataSaldos?.montoLimiteCredito)
    const [montoNuevoCorte, setMontoNuevoCorte] = useState(dataSaldos?.montoNuevoCorte)
    const [nuevoMensaje, setNuevoMensaje] = useState(dataSaldos?.nuevoMensaje)
    const [nombre, setNombre] = useState(dataSaldos?.nombreTitular)
    const [telefono, setTelefono] = useState(dataSaldos?.phone)

    const [cuentaNueva, setCuentaNueva] = useState(dataSaldos?.cuentaNueva)
    const [responseOrigin, setResponseOrigin] = useState(dataSaldos?.responseOrigin)

    const diasFaltantes = (fechaLimite) => {
        let fecha = new Date()
        let fechaService = fechaLimite 
        let fechaActual = Number( `1${ String(fecha.getFullYear()).substring(2) }${fecha.getMonth() + 1}${fecha.getDate()}` )
        let diasFaltantes = fechaService - fechaActual

        return diasFaltantes
    }

    // explain keys
        // "new_type": newType
        // "new_message": nuevoMensaje
        // "fecha_pago": fechaPago
        // "new_balance_cutting": montoNuevoCorte
        // "minimum_to_pay": montoMinimo
        // "monto_pendiente_pago": montoPendPago
        // "credit_imit": montoLimiteCredito

    useEffect(() => {
        if (dataSaldos) {
            setEscenarioHome(dataSaldos?.escenarioHome)
            setTitulo(dataSaldos?.titulo)
            setAccountNumber(dataSaldos?.accountNumber)
            setNewType( Number(dataSaldos?.newType) )
            setCardending(dataSaldos?.cardending)
            setFechaPago(dataSaldos?.fechaPago)
            setFechaLimite(dataSaldos?.fechaLimite)
            setSaldoDisponible(dataSaldos?.saldoDisponible)
            setMontoMinimo(dataSaldos?.montoMinimo)
            setMontoLimiteCredito(dataSaldos?.montoLimiteCredito)
            setMontoNuevoCorte(dataSaldos?.montoNuevoCorte)
            setNuevoMensaje(dataSaldos?.nuevoMensaje)
            setNombre(dataSaldos?.nombreTitular)
            setTelefono(dataSaldos?.phone)

            setCuentaNueva( Number(dataSaldos?.cuentaNueva) )
            setResponseOrigin(dataSaldos?.responseOrigin)

            // console.log('dataSaldos: ', dataSaldos) 
        }

        if( cuentaNueva === 0 ){
            setEscenarioHome(8)
        }
        else if( cuentaNueva === 1 ){

            if( newType === 0 ){
                if( responseOrigin?.montoNuevoCorte <= 0 && responseOrigin?.montoMinimo <= 0 ){
                    setEscenarioHome(0)
                }
                else if( responseOrigin?.montoNuevoCorte > 0 && responseOrigin?.montoMinimo === 0){
                    setEscenarioHome(1)
                }
                else if( responseOrigin?.montoNuevoCorte > 0 && responseOrigin?.montoMinimo > 0 ){
                    setEscenarioHome(2)
                }
                else if( responseOrigin?.montoNuevoCorte <= 0 && responseOrigin?.montoMinimo > 0 ){
                    // este caso hay que preguntarlo por que existe en la cuenta de clau
                    setEscenarioHome(2)
                }
            }
            else if( newType === 1 ){
                // if( responseOrigin?.montoNuevoCorte > 0 && responseOrigin?.montoMinimo > 0 || ( diasFaltantes(fechaLimite) >= 0 && diasFaltantes(fechaLimite) <= 5) ){
                //     setEscenarioHome(3)
                // }
                setEscenarioHome(3)
            }
            else if( newType === 2 ){
                // if( responseOrigin?.montoNuevoCorte > 0 && responseOrigin?.montoMinimo > 0 || diasFaltantes(fechaLimite) === 0 ){
                //     setEscenarioHome(4)
                // }
                setEscenarioHome(4)
            }
            else if( newType === 3 ){
                // if( responseOrigin?.montoNuevoCorte > 0 && responseOrigin?.montoMinimo > 0 || diasFaltantes(fechaLimite) < 0 ){
                //     setEscenarioHome(5)
                // }
                setEscenarioHome(5)
            }
            else if( newType === 4 ){
                diasFaltantes(fechaLimite)
                // if( responseOrigin?.montoNuevoCorte > 0 && responseOrigin?.montoMinimo > 0 && responseOrigin?.montoLimiteCredito > 0 ){
                //     setEscenarioHome(6)
                // }
                setEscenarioHome(6)
            }
            else if( newType === 5 ){
                // if( responseOrigin?.montoNuevoCorte > 0 && responseOrigin?.montoMinimo > 0 && responseOrigin?.montoLimiteCredito === 0){
                //     setEscenarioHome(7)
                // }
                setEscenarioHome(7)
            }
        }

    }, [dataSaldos])

    return {
        escenarioHome,
        titulo,
        accountNumber,
        newType,
        cardending,
        fechaPago,
        fechaLimite,
        saldoDisponible,
        montoMinimo,
        montoLimiteCredito,
        montoNuevoCorte,
        nuevoMensaje,
        nombre,
        telefono
    }
}


export function DisponibleFirstCredito(props) {
    const {
        saldoDisponible,
        titulo,
        accountNumber,
        newType,
        montoMinimo,
        escenarioHome
    } = props

    const [, setcopied] = useState(false);
    const onCopy = () => { setcopied(true); }

    return(
        <div className={styles?.disponibleFirst}>
            <div className={styles?.creditoDispTitle}>
                <p className={styles?.titleCredito}>Crédito disponible</p>
                <p className={styles?.saldoTitleCredito}>{ saldoDisponible }</p>
            </div>
            {escenarioHome === 8
                ? 
                    <CopyToClipboard text={accountNumber} onCopy={() => setcopied(true)}>
                        <div className={styles?.cardWhiteClient}>
                            <p className={styles?.idCredito}>ID crédito: <span className={styles?.bold}>{ accountNumber }</span>
                            <span className={styles?.copyBtn} onClick={onCopy}></span>
                            </p>
                        </div>
                    </CopyToClipboard>
                : null
            }
        </div>
    )
}


export function CardCreditoMessageOk(props) {
    const {
        cardending
    } = props

    return(
        <div className={`${styles?.cardCreditoStyle} ${styles?.cardCreditoMessage}`}>
            <div className={styles?.textGreen}>¡Estás al corriente!</div>
            <div>No tienes saldo pendiente por pagar este mes</div>
            <div className={styles?.contBtnsPago}>
                <ElegirPlan cardending={cardending} textButton="Adelantar pago" />
            </div>
        </div>
    )
}


export function CardCreditoMessageOterStatus(props) {
    const {
        cardending,
        fechaLimite,
        fechaPago,
        montoMinimo,
        nuevoMensaje,
        escenarioHome
    } = props

    
    const [titleMessage, setTitleMessage] = useState('Pago antes del')
    useEffect(()=>{
        if(escenarioHome >= 5){
            setTitleMessage('Pago vencido el')
        }else{
            setTitleMessage('Pago antes del')
        }
    },[escenarioHome])
    
    
    const [serviceMessage, setServiceMessage] = useState(nuevoMensaje)
    useEffect(()=>{
        if(escenarioHome === 7){
            setServiceMessage('<strong>¡Urgente!</strong> realiza tu pago')
        }
        else if(escenarioHome === 6){
            setServiceMessage('<strong>¡Urgente!</strong> realiza tu pago para seguir utilizando tu crédito')
        }
        else if(escenarioHome === 5){
            setServiceMessage('Paga ahora y evita que aumenten los cargos')
        }
        else{
            setServiceMessage(nuevoMensaje.replace('HOY', '<strong>HOY</strong>'))
        }
    },[escenarioHome])

    return(
        <div className={`${styles?.cardCreditoStyle} ${styles?.cardCreditoMessage}`}>
            {escenarioHome != 2
                ?
                    <>
                        <div className={`${styles?.messageResponse} ${ escenarioHome >= 5 ? styles?.dangerResponse : styles?.warinigResponse}`}  dangerouslySetInnerHTML={{ __html: serviceMessage}} />
                        {escenarioHome >= 3 && escenarioHome <= 4
                            ?
                                <div className={styles?.payDeadLine}>{titleMessage} <span>{dateFormatDDMM(fechaPago)}</span></div>
                            : null
                        }
                    </>
                :
                    <div className={styles?.payDeadLine}>{titleMessage} <span>{dateFormatDDMM(fechaPago)}</span></div>
            }
            <div className={styles?.montlyPayment}>{montoMinimo}</div>
            <div className={styles?.contBtnsPago}>
                <PagarPlan cardending={cardending} nameButton="Pagar" />
                <ElegirPlan cardending={cardending} textButton="Elegir otro monto" />
            </div>
        </div>
    )
}


export function BotoneraSeccionCredito(props) {

    const {
        titulo,
        accountNumber,
        nombre,
        telefono
    } = props

    const history = useHistory();
    const [showModal, SetShowModal] = useState(false);
    const [, setcopied] = useState(false);

    // redirecciona a movimientos
    const handleMovimientos = () => {
        dataLayerButtons({ eventName: "credito_movimientos" });
        history.push(`${BASE_PATH}${SUB_DIRECTORY}movimientos/movimientos-tarjeta`);
    };

    // redirecciona a estado de cuenta
    const handleEstadoDeCuenta = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}estado-cuenta/solicitar-estado-cuenta`);
    };

    const handleMiCuenta = () => {
        SetShowModal(true)
    }

    const handleClose = () => {
        SetShowModal(false)
    }
    
    const onCopy = () => { setcopied(true); }

    return(
        <>
            <div className={styles?.cardButtonsState}>
                <div onClick={handleMiCuenta}><div className={styles?.iconMyAccount}></div>ID Mi Crédito</div>
                <div onClick={handleEstadoDeCuenta}><div className={styles?.iconStateCount}></div>Estados de cuenta</div>
                <div onClick={handleMovimientos}><div className={styles?.iconMovements}></div>Movimientos</div>
            </div>
            {showModal &&
                <ModalCredito type="newCreditModal" onClose={handleClose} closeBody="modalCredito" >
                    <div>
                        <p className={styles?.titleModal}>Mi cuenta</p>
                        <CopyToClipboard text={accountNumber} onCopy={() => setcopied(true)}>
                            <div className={styles?.cardWhiteClient}>
                                <p className={styles?.idCredito}>ID crédito: <span className={styles?.bold}>{ accountNumber }</span>
                                <span className={styles?.copyBtn} onClick={onCopy}></span>
                                </p>
                            </div>
                        </CopyToClipboard>
                        <p className={styles?.nameClient}>{ nombre }</p>
                        {telefono
                            ?
                                <p className={styles?.phoneClient}>Celular: { telefono }</p>
                        
                            : null
                        }
                    </div>
                </ModalCredito>
            }
        </>
    )
}


export function CreditoDisponibleCredito(props) {
    const {
        saldoDisponible,
        montoLimiteCredito
    } = props

    const [showModal, SetShowModal] = useState(false);

    const handleClose = () => {
        SetShowModal(false)
    }

    const dataInfo = () => {
        SetShowModal(true)
    }

    return(
        <>
            <div className={styles?.cardCreditoStyle}>
                <div className={styles?.creditoDisponible}>
                    <p className={styles?.textCreditoDisp}>Crédito disponible: <span className={styles?.info} onClick={dataInfo}>i</span></p>
                    <div className={styles?.contentMontos}>
                        <p className={styles?.saldoDisponible}>{saldoDisponible}</p>
                        <p className={styles?.montoLimite}> de {montoLimiteCredito}</p>
                    </div>
                </div>
            </div>
            {showModal &&
                <ModalCredito type="newCreditModal" onClose={handleClose} closeBody="modalCredito" >
                    <div>
                        <p className={styles?.titleModal}>¿Qué es mi crédito disponible?</p>
                        <div className={styles?.contTextModal}>
                            <p className={styles?.textModal}>Es la cantidad que puedes utilizar para tus compras.</p>
                            <p className={styles?.textModal}>Cada que realices un pago de una mensualidad recuperarás parte de tu crédito disponible para poder seguir comprando.</p>
                        </div>
                    </div>
                </ModalCredito>
            }
        </>
    )
}


export function ProximoCorteCredito(props) {
    const {
        fechaPago,
        fechaLimite,
        typeView,
        escenarioHome
    } = props

    return(
        fechaPago && fechaLimite
            ?
                escenarioHome != 7 && escenarioHome != 4 && escenarioHome != 3
                    ?
                        <div className={styles?.cardCreditoStyle}>
                            <p className={styles?.boldJustifyContent}>
                                <span>Próximo corte</span>
                                <span className={`${styles?.strong} ${styles?.big}`}>{dateFormatDDMM(fechaLimite)}</span>
                            </p>
                            {escenarioHome === 0
                                ?
                                    typeView === 1
                                        ?
                                            <>
                                                <p className={styles?.textProximoCorte}>¡Anímate! Si compras con tu crédito antes de esta fecha,</p> 
                                                <p className={styles?.textProximoCorte}>pagarás tu primer mensualidad el <span className={styles?.strong}>{dateFormatDDMM(fechaPago)}</span> </p>
                                            </>
                                        :
                                            <p className={styles?.textProximoCorte}>¡Anímate! Si compras con tu crédito antes de esta fecha, pagarás tu primer mensualidad el <span className={styles?.strong}>{dateFormatDDMM(fechaPago)}</span> </p>
                                :
                                    <>
                                        <p className={styles?.textProximoCorte}>Si compras con tu crédito antes de esta fecha,</p> 
                                        <p className={styles?.textProximoCorte}>pagarás hasta la fecha de pago del siguiente corte.</p>
                                    </>
                                    
                            }
                        </div>
                    : null
            : null
    )
}


export function WhatsappCredito() {
    const numeroWA = "525518110000"
    const promoClick = () => {
        try {
            window.onPromoClick("section", "credito", 'Sirena', 1);
        } catch (e) {
            console.log('onPromoClick: ', e);
        }
        window.open(`https://api.whatsapp.com/send?phone=${numeroWA}&text=Necesito%20ayuda%20con%20mi%20cr%C3%A9dito`, '_blank');
    }

    return (
        <div className={styles?.cardWhats} onClick={promoClick}>
            <div className={styles?.contImgWhats}>
                <img  className={styles?.imgWhats} src={`/credito-claroshop/img/newCredito/whatsapp.png`} alt="whatsapp" />
                <i className={styles?.icoWhats}></i>
            </div>
            <div className={styles?.cardInternalWhats}>
                <div className={styles?.text}>
                    <p>¿Tienes dudas?</p>
                    <p className={styles?.cardGreen}>En línea</p>
                </div>
                <p>Chatea ahora con un experto</p>
            </div>
        </div>
    )
}


export function UltimosVistos(props) {
    const {
        escenarioHome
    } = props


    return (
        escenarioHome <= 2 || escenarioHome === 8
            ? <HistorialNav />
            : null
    )
}